export const Images = [
  { image: require("./../../assets/bilder/IMG_7417.jpeg") },
  { image: require("./../../assets/bilder/2017-1.jpg") },
  { image: require("./../../assets/bilder/IMG_7416.jpeg") },
  { image: require("./../../assets/bilder/IMG_7961.JPG") },
  { image: require("./../../assets/bilder/2017-24.jpg") },
  {
    image: require("./../../assets/bilder/6cb954b4-325f-4cd2-aaa3-0260008fc962.JPG"),
  },
  { image: require("./../../assets/bilder/2017-10.jpg") },
  { image: require("./../../assets/bilder/cake.png") },
  { image: require("./../../assets/bilder/2017-3.jpg") },
  { image: require("./../../assets/bilder/2017-4.jpg") },
  {
    image: require("./../../assets/bilder/10185953-ed29-4c10-b9d1-91f4c97047cf.JPG"),
  },
  {
    image: require("./../../assets/bilder/72ab2dbe-a221-4450-9605-479c3cd30467.JPG"),
  },
  { image: require("./../../assets/bilder/fruehstueck_01.jpg") },
  { image: require("./../../assets/bilder/fruehstueck_02.jpg") },
  {
    image: require("./../../assets/bilder/4e900b70-8cfd-47ee-93fe-861ffb90ed4f.JPG"),
  },
  { image: require("./../../assets/bilder/2017-9.jpg") },
  {
    image: require("./../../assets/bilder/02a590d9-0653-496b-be79-10a3144b21ed.JPG"),
  },
  {
    image: require("./../../assets/bilder/df2d8716-ad33-463c-9aef-eec1afff6a65.JPG"),
  },
  {
    image: require("./../../assets/bilder/256cd5f4-1261-47d0-b84b-e849a25d17bb.JPG"),
  },
  {
    image: require("./../../assets/bilder/722f85d2-52ba-4332-8bc6-828146a5c025.JPG"),
  },
  {
    image: require("./../../assets/bilder/945596fe-122e-4a51-b63c-daa7a6356b00.JPG"),
  },
];
